import React from "react";
import { FC } from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import useUserQueries from "../../../hooks/useUserQueries";
import { useQuery } from "react-query";
import Loading from "../../../../../components/Loading";
import { mutateErrors } from "../../../../../utils";
import Error from "../../../../../components/Error";
import Container from "@material-ui/core/Container";
import PageHeader from "../../../../../components/PageHeader";
import Grid from "@material-ui/core/Grid";
import UserListItem from "../../../components/admin/UserListItem";
import Button from "../../../../../components/Button";
import { useAddSupportConfig } from "../../../hooks/useAddSupport";
import { useWizard } from "../../../../wizard/context";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
}));

const AdminsPage: FC = () => {
  const classes = useStyles();
  const { fetchAll } = useUserQueries();

  const { isLoading, isFetching, refetch, isError, error, data } =
    useQuery<any>("admins", () => fetchAll("0,1,5"));

  const { getAddSupportConfig } = useAddSupportConfig();
  const { openWizard } = useWizard();

  const handleAddSupport = async () => {
    const result = await openWizard(getAddSupportConfig());

    if (result) {
      refetch();
    }
  };

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  const users = data.data;

  return (
    <>
      <Container maxWidth="lg">
        <PageHeader
          title={"Admins"}
          subtitle={"Here are listed admins"}
          endAdornment={
            <Button
              color={"success"}
              variant={"contained"}
              onClick={handleAddSupport}
            >
              Add Support
            </Button>
          }
        />
      </Container>
      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={2}>
          {users.length ? (
            users.map((user: any, index) => (
              <UserListItem
                user={user}
                refetch={refetch}
                key={`AdminListItem_${index}`}
              />
            ))
          ) : (
            <Error text={"No Admins Found"} />
          )}
        </Grid>
      </Container>
    </>
  );
};

export default React.memo(AdminsPage);
